import type { TOC } from '@ember/component/template-only';
import MySourcesList from '../../components/my-sources-list.gts';
import MobileHeader from '../../components/mobile-header.gts';

interface Signature {
  Args: {};
}

const MySourcesIndexTemplate: TOC<Signature> = <template>
  <MobileHeader @title="My Sources" />
  <h1 class="mb-6 hidden text-3xl font-bold lg:block">My Sources</h1>
  <MySourcesList />
</template>;

export default MySourcesIndexTemplate;
